
import {
  MDBBtn,
  MDBCard, MDBCardBody,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBRow,MDBAlert,
  MDBTypography,
  MDBCardFooter
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {Link, useParams } from 'react-router-dom';
import Upload from '../reusables/Upload';
const NoReceipts = ({ baseUrl , isReceipts, setReceipts, entitiesCreated, setEntitiesCreated}) => {
  const {type} = useParams();

  const [visibility, setVisibility] = useState(false);
  return (
    <MDBContainer breakpoint="xxl" className="mt-5 justify-content-center align-items-center grainy-gradient-intro">
       <MDBAlert open={entitiesCreated}
        className='w-50 justify-content-center align-items-center text-center' color='success'
        position="top-center"
        autohide
        delay={5000}
        appendToBody
        onClose={() => setEntitiesCreated(false)}
      >
        Success<MDBBtn onClick={() => setEntitiesCreated(false)}  tag='a' color='none' className='m-1' style={{ color: '#3b5998' }}><i className="fas fa-times-circle me-3"></i></MDBBtn>
      </MDBAlert>
      <MDBCard><MDBCardBody>
      <MDBRow md="12" className="text-center white-text wow fadeIn mb-3">
        <div className="col-12">
          <section className="my-5 text-center  mt-5"  >
      

           {visibility && (
       <MDBRow tag='dl' className="my-1 text-center">
<MDBCol>

<MDBTypography variant="h2"  color="info">
          Better Scans, Smoother Workflow: Less Manual, More Magic
        </MDBTypography>
</MDBCol>
       <MDBCol tag='dd' sm='12' className='text-center  mt-5' >
         <MDBTypography variant='h4' className='text-center' color='primary'>Use a Clear Background</MDBTypography>
         <MDBTypography variant='h6' color='primary' >A clear and contrasted background can help minimize confusion. Use a contrasting color to your document.</MDBTypography>
       </MDBCol>

       <MDBCol tag='dd' sm='12' className=' ' color='primary'>
         <MDBTypography variant='h4' className=' ' color='primary'> Maintain Uniform Lighting</MDBTypography>
         <MDBTypography variant='h6' className=' ' color='primary'>Try to take the picture under even, bright light. Avoid shadows on the document.</MDBTypography>
       </MDBCol>

       <MDBCol tag='dd' sm='12' >
         <MDBTypography variant='h4' className=' ' color='primary'> Keep Document Flat</MDBTypography>
         <MDBTypography variant='h6' className=' ' color='primary'>Ensure that the document is as flat as possible. Wrinkles and curves can distort the text and make it harder for system to read.</MDBTypography>
       </MDBCol>


       <MDBCol tag='dd' sm='12' >
         <MDBTypography variant='h4' className=' ' color='primary'>Position Camera Correctly</MDBTypography>
         <MDBTypography variant='h6' className=' ' color='primary'>Position the camera directly above the document. The camera should be parallel to the document to prevent distortion of the text.</MDBTypography>
       </MDBCol>


       <MDBCol tag='dd' sm='12' >
         <MDBTypography variant='h4' className=' ' color='primary'>Use the Highest Resolution</MDBTypography>
         <MDBTypography variant='h6' className=' ' color='primary'> Use the highest resolution your camera allows.</MDBTypography>

       </MDBCol>
     </MDBRow >
    )}
     
     <Upload documentType={type} baseUrl={baseUrl} setReceipts={setReceipts} entitiesCreated={entitiesCreated} setEntitiesCreated={setEntitiesCreated}/>   
     
   
      <span style={{ position: 'absolute', top: -4, right: -2 }}>
                 
                  <MDBBtn color="none" tag="a" size='lg' floating onClick={() => setVisibility(!visibility)}>
                  <MDBIcon fas icon="info" />
      </MDBBtn>
                   
                      </span>

    </section>
        </div>
      </MDBRow>
      </MDBCardBody>
      <MDBCardFooter className="mt-5 justify-content-center align-items-center grainy-gradient-intro text-center ">
    
              <Link to={{ pathname: "/domain/entities", state: { fetchData: true } }} >
                <MDBBtn block color='warning'>go to inventory</MDBBtn>
              </Link>
            

      </MDBCardFooter>
      </MDBCard>
    </MDBContainer>
      )
};
NoReceipts.propTypes = {
  baseUrl: PropTypes.string,
  isReceipts: PropTypes.bool,
  setReceipts: PropTypes.func,
  entitiesCreated: PropTypes.bool,
  setEntitiesCreated: PropTypes.func,
};

export default NoReceipts;
